// eslint-disable-next-line quotes
const workerCode = `{code}`;
const workerName = '__maptalks.three__';

export function getWorkerName() {
    return workerName;
}

export function getWorkerCode() {
    return workerCode;
}
